import { render, staticRenderFns } from "./PublicSearchInput.vue?vue&type=template&id=5063b256&"
import script from "./PublicSearchInput.vue?vue&type=script&lang=js&"
export * from "./PublicSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports